<template>
  <div v-if="terms" class="full-width full-height">
    <template v-if="missingQualifiers" class="col-md-12">
      <div class="text-positive">
        You can create license terms qualifiers
        <a href="/license-qualifier-labels" target="_blank" class="text-primary">here</a>.
      </div>
    </template>
    <template v-if="terms && terms.length > 0" class="col-md-12">
      <transition-group appear enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
        <div v-for="(label, index) in terms" :key="`term_${index}`" class="row q-col-gutter-sm q-mt-sm">
          <div :key="`name-${index}`" class="col-md-2">
            <q-input :id="`name-${index}`" v-model="label.name" stack-label label="Name" readonly outlined />
          </div>
          <div :key="`active-${index}`" class="col-md-2">
            <EnhancedQSelect
              v-model="label['active']"
              :options="activeOptions"
              :filter="false"
              label="Active"
              @input="$emit('input', terms)"
            />
          </div>
          <div :key="`allowed-${index}`" class="col-md-2">
            <EnhancedQSelect
              v-model="label['status']"
              :options="statusOptions"
              :display-value="displayStatus(label['status'])"
              :filter="false"
              label="Allowed"
              @input="$emit('input', terms)"
            />
          </div>
          <div :key="`qualifiers-${index}`" class="col-md-2">
            <q-select
              v-if="label.qualifierOptionsUi"
              v-model="label['qualifiers']"
              :options="label.qualifierOptionsUi"
              :disable="!label.qualifierOptionsUi.length"
              multiple
              map-options
              label="Qualifiers"
              color="tertiary"
              outlined
              @input="$emit('input', terms)"
            />
          </div>
          <div :key="`description-${index}`" class="col-md-4">
            <q-input
              v-model="label['description']"
              class="lm-textarea lm-textarea--small"
              type="textarea"
              stack-label
              label="Description"
              outlined
              @input="$emit('input', terms)"
            />
          </div>
        </div>
      </transition-group>
    </template>
    <template v-else class="col-md-12">
      <div class="text-warning q-mb-md">
        Create some
        <router-link :to="{ name: 'license-term-labels' }" class="text-primary">license terms labels</router-link>
        and
        <router-link :to="{ name: 'license-qualifier-labels' }" class="text-primary"
          >license qualifier labels</router-link
        >.
      </div>
    </template>
  </div>
</template>

<script>
import { cloneDeep, capitalize } from 'lodash'
import { mapState } from 'vuex'
// Components
import EnhancedQSelect from '@components/general/EnhancedQSelect'

export default {
  components: { EnhancedQSelect },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      missingQualifiers: false,
      terms: null
    }
  },
  computed: {
    ...mapState({
      statuses: state => state.licensePeriods.termStatuses
    }),
    statusOptions() {
      if (!this.statuses) return
      return this.statuses.map(s => ({
        label: this.displayStatus(s),
        value: { ...s }
      }))
    },
    activeOptions() {
      return [
        {
          label: 'Yes',
          value: true
        },
        {
          label: 'No',
          value: false
        }
      ]
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal === oldVal || !newVal || (newVal && !newVal.length)) {
        return
      }
      let terms = this.processTerms(cloneDeep(newVal))
      this.$set(this, 'terms', terms)
    }
  },
  created() {
    let terms = this.processTerms(cloneDeep(this.value))
    this.$set(this, 'terms', terms)
  },
  methods: {
    processTerms(terms) {
      return terms.map(term => {
        if (!term.qualifierOptionsUi) {
          term.qualifierOptionsUi = this.generateOptions({
            collection: term.qualifierOptions,
            valueAsObject: false
          })
          term.qualifiers = cloneDeep(term.qualifiers).map(item => item.id)
          if (!term.qualifierOptionsUi.length) this.missingQualifiers = true
        }
        return term
      })
    },

    displayStatus(s) {
      return s.name === 'n/a' ? s.name.toUpperCase() : capitalize(s.name)
    }
  }
}
</script>
